import { useCallback, useState } from 'react';
import { ITemplateBaseDetails } from '../../../../lib/types';
import { useTemplate, useUpdateTemplate } from '../template.service';
import { logError, sleep } from '../../../../lib/utils';
import { Loader } from '../../../_core/loader.component';
import { ICreateTemplateFormValues } from '../create/create-template-form.component';
import { CreateTemplateNestedContainer } from '../create/create-template-form-nested.container';

export interface IEditTemplateContainerProps {
  close: () => void;
  template: ITemplateBaseDetails;
}

export const EditTemplateContainer = ({ close, template: templateDetails }: IEditTemplateContainerProps) => {
  const { template } = useTemplate(templateDetails._id);
  const { updateTemplate } = useUpdateTemplate(templateDetails);

  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  const handleUpdate = useCallback(
    async (props: ICreateTemplateFormValues) => {
      if (!template) setSubmitError('Unable to update template');
      else
        try {
          const result = await updateTemplate({ ...props }, template);
          if (result?.template?._id) {
            setSubmitError(null);
            setSuccess('Updated template successfully!');

            await sleep(500);
            close();
          } else {
            setSuccess(null);
            setSubmitError('Failed to update template');
          }
        } catch (err) {
          const errMsg = 'Failed to update template';
          setSuccess(null);
          setSubmitError(errMsg);
          logError(errMsg, (err as Error).message);
        }
    },
    [close, template, updateTemplate]
  );

  if (!template) return <Loader />;
  return (
    <CreateTemplateNestedContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      onSubmit={handleUpdate}
      template={template}
      type={template.type}
      version={template.version}
    />
  );
};
